/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import cookie from 'react-cookies'
import {baseURL} from '../BaseComponent/configTheme'
import $ from 'jquery'
import {ExcelExport, grid, ExcelExportColumn} from '@progress/kendo-react-excel-export'
import Loader from '../loaders/loader'

class OrderProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',

      providers: [],
      loading: false
    }
  }
  componentDidMount() {}

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  orderProvider() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let operatorName = document.getElementById('operatorName').value.trim()

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/plans/count?fromTime=${minDate}&toTime=${maxDate}&operatorName=${operatorName}`
      )
    }
  }

  exportExcel() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let operatorName = document.getElementById('operatorName').value.trim()
    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `report/jasper/supplier/plans/count/json?fromTime=${minDate}&toTime=${maxDate}&operatorName=${operatorName}`,
          {}
        )
        .then((res) => {
          if (res.data.error === null) {
            this.setState(
              {
                loading: false,
                excel: res.data.object.supplierPlanReportViewList
              },
              () => {
                this._export.save(this.state.excel)
              }
            )
          } else {
            this.setState({
              loading: false
            })
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  render() {
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName=" نقص برنامه کاری تامین کنندگان.xls"
          >
            <ExcelExportColumn
              key={'providerId'}
              field={'providerId'}
              title={'شناسه تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'providerName'}
              field={'providerName'}
              title={'نام تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'fullName'}
              field={'fullName'}
              title={'کاربر مسئول'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'numberOfProductsWithPlan'}
              field={'numberOfProductsWithPlan'}
              title={'دارای برنامه تامین'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'numberOfProductsWithoutPlan'}
              field={'numberOfProductsWithoutPlan'}
              title={'بدون برنامه تامین'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li> نقص برنامه کاری تامین کنندگان</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p> نقص برنامه کاری تامین کنندگان</p>
            </div>

            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ شروع از"
              toLabel="تاریخ شروع تا"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />
            <div className="formComponent">
              <label>کاربر مسئول : </label>
              <input type="text" id="operatorName" className="form-control" />
            </div>
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.orderProvider.bind(this)}>
                نقص برنامه کاری تامین کنندگان
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.exportExcel.bind(this)}>
                خروجی اکسل
              </button>

              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default OrderProvider
